<template>
  <div>
    <b-navbar
      :toggleable="navbarBottom ? false : 'md'"
      type="dark"
      variant="dark"
      v-bind:class="{
        'host-navbar': hostNavbar,
        'admin-navbar': adminNavbar,
        'debug-navbar': debugNavbar,
        'py-1': noNavbarPadding
      }"
      v-bind:fixed="navbarBottom ? 'bottom' : 'top'"
    >
      <b-navbar-brand v-if="showBrand">
        <router-link class="navbar-brand" v-bind:to="theBrandRoute">
          <img src="../assets/logo_white.svg" width="30" height="30" alt />
          <span>{{ title }}</span>
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle
        v-bind:target="collapseID"
        v-bind:class="{ 'my-1': navBarToggleBottomPadding }"
      >
        <b-icon-list />
        <span v-if="hasNotification" class="blink-opacity">
          <b-icon-exclamation-circle-fill class="ml-1" />
        </span>
      </b-navbar-toggle>

      <b-collapse v-bind:id="collapseID" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="subtitle && showSubtitle" href="#" disbaled>
            {{ subtitle }}
          </b-nav-item>
          <NavbarItem
            v-for="item in items"
            v-bind:key="item.id"
            v-bind:item="item.item"
            v-bind:replace="replaceInsteadOfPush"
          ></NavbarItem>
        </b-navbar-nav>

        <div v-if="showSeparator" class="dropdown-divider ml-auto"></div>
        <b-navbar-nav>
          <div v-if="!navbarBottom">
            <router-link class="nav-item nav-link" to="/donations">
              <b-badge id="nav-donate" variant="warning">Donate</b-badge>
            </router-link>
          </div>

          <NavbarItem
            v-for="item in itemsRight"
            v-bind:key="item.id"
            v-bind:item="item.item"
            v-bind:replace="replaceInsteadOfPush"
          ></NavbarItem>

          <b-nav-item disabled v-if="canShowLogout" class="navUser">
            {{ userName }}
          </b-nav-item>
          <div v-if="canShowLogout">
            <router-link class="nav-item nav-link" to="/logout"
              >Logout</router-link
            >
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import NavbarItem from "./NavbarItem";

export default {
  name: "Navbar",
  props: {
    items: {
      default() {
        return [];
      }
    },
    itemsRight: {
      default() {
        return [];
      }
    },
    showBrand: {
      default: true
    },
    showLogout: {
      default: true
    },
    showDonations: {
      default: true
    },
    showSubtitle: {
      default: true
    },
    navbarBottom: {
      default: false
    },
    hostNavbar: {
      default: false
    },
    adminNavbar: {
      default: false
    },
    title: {
      default: "TopQuiz"
    },
    subtitle: {
      default: ""
    },
    brandRoute: {
      default: "/"
    },
    replaceInsteadOfPush: {
      default: false
    }
  },
  computed: {
    hasNotification() {
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        if (item.item.notificationGetter == undefined) {
          continue;
        }
        if (this.$route.path.startsWith(item.item.to)) {
          continue;
        }
        var notify = this.$store.getters[item.item.notificationGetter];
        if (notify) {
          return true;
        }
      }

      return false;
    },
    theBrandRoute() {
      if (this.$store.getters.isLoggedIn) {
        return this.brandRoute;
      }

      return "/";
    },
    canShowLogout() {
      return this.showLogout && localStorage.getItem("session_key") !== null;
    },
    userName() {
      return this.$store.state.userName;
    },
    showSeparator() {
      return (
        (!this.navbarBottom && this.showDonations) ||
        this.canShowLogout ||
        this.itemsRight.length > 0
      );
    },
    smallNavbar() {
      return ["sm", "md"].includes(this.$store.state.bootstrapScreenSize);
    },
    noNavbarPadding() {
      return ["xs", "sm", "md"].includes(this.$store.state.bootstrapScreenSize);
    },
    navBarToggleBottomPadding() {
      return this.noNavbarPadding && this.navbarBottom;
    },
    debugNavbar() {
      return this.$settings.verbose;
    }
  },
  components: {
    NavbarItem
  },
  data() {
    return {
      collapseID: this.collapseID
    };
  },
  beforeCreate() {
    this.collapseID = "" + Math.ceil(Math.random() * 999999);
  }
};
</script>

<style scoped>
.navUser .nav-link {
  color: white !important;
}
</style>
